import { FunctionComponent } from "react";

import { useTheme } from "@bps/fluent-ui";
import { CopyableGuid } from "@components/CopyableText";

interface ServerMigrationGuidProps {
  value: string;
}

// overflowWrap lets a narrow dialog wrap the guid rather than pushing the copy
// button over neighbouring content.
export const ServerMigrationGuid: FunctionComponent<ServerMigrationGuidProps> = ({
  value
}) => {
  const theme = useTheme();

  return (
    <CopyableGuid
      value={value}
      variant="small"
      color={theme.palette.themeSecondary}
      styles={{ root: { overflowWrap: "anywhere" } }}
    />
  );
};
